// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__xpNpg","header":"ReportDetails_header__3xo8J","title":"ReportDetails_title__2-JeC","left":"ReportDetails_left__12mbZ"};